import { ApplicationStatusText } from '@/src/modules/checkout/StyledComponents'
import { MAX_CARDS, MAX_PURCHASE_AMOUNT } from '@/src/modules/checkout/strings'
import { useEffect } from 'react'

const KYCApplicationDeniedContent = ({
    totalLoadValue,
    numberOfCards,
    refetchCart,
}: {
    totalLoadValue: number
    numberOfCards: number
    refetchCart: Function
}) => {
    const excessLoadValue: string = (
        totalLoadValue - MAX_PURCHASE_AMOUNT
    ).toFixed(2)
    const excessCards: number = numberOfCards - MAX_CARDS
    const tooManyCards = excessCards > 0
    const tooMuchLoadValue = Number(excessLoadValue) > 0

    const actionText: string = `${
        tooMuchLoadValue ? `$${excessLoadValue} in card load value` : ''
    }${tooMuchLoadValue && tooManyCards ? ' and ' : ''}${
        tooManyCards ? `${excessCards} cards` : ''
    }`

    useEffect(() => {
        if (!tooMuchLoadValue && !tooManyCards) {
            refetchCart()
        }
    }, [refetchCart, tooManyCards, tooMuchLoadValue])

    return (
        <>
            <h1 style={{ fontSize: '1.75rem' }}>
                An update on your application status
            </h1>
            <ApplicationStatusText>
                After reviewing the information previously supplied to our
                compliance team, your application to purchase in bulk on
                PerfectGift.com has been denied. If you’re a corporate buyer
                looking for support for larger programs, please{' '}
                <a href={'/corporate/get-started?variant=default'}>
                    submit your details to be contacted by an Account Executive
                    in minutes
                </a>
                . For additional details on why your application was not
                accepted, you can contact us at{' '}
                <a href={'mailto:fraud@perfectgift.com'}>
                    fraud@perfectgift.com.
                </a>
            </ApplicationStatusText>
            <ApplicationStatusText>
                To continue to checkout, please remove {actionText} from your
                cart.
            </ApplicationStatusText>
        </>
    )
}

export default KYCApplicationDeniedContent
